<button [ngStyle]="backgroundStyle"
        (mouseover)="overRoundedButton()"
        (mouseleave)="leaveRoundedButton()"
        class="rounded-button" >
        <a href="https://api.whatsapp.com/send?phone=541169855258&text=Hola%20Nicpetrol!%20Tengo%20una%20consulta." target="_blank">
            <img [src]="src" class="rounded-button__img"/>
        </a>
</button>